import { TableBodyCellProps, TableColumn, TableProps } from '@vtex/admin-ui';
import { Product } from '../../../../shared';
import { Table } from '../../../../components';

type Props = {
  selectedProduct: Product[];
  columns: TableColumn<Product>[];
  getBodyCell: (
    column: TableColumn<Product>,
    item: Product,
  ) => TableBodyCellProps<Product>;
  getTable: () => TableProps<Product>;
};

export const SelectedProductsTable = ({
  columns,
  selectedProduct,
  getBodyCell,
  getTable,
}: Props) => {
  return (
    <Table
      columns={columns}
      data={selectedProduct}
      withoutHead
      getBodyCell={getBodyCell}
      getTable={getTable}
    />
  );
};
